import { render, staticRenderFns } from "./GradientDonutChart.vue?vue&type=template&id=34c5c044&scoped=true&"
import script from "./GradientDonutChart.vue?vue&type=script&lang=js&"
export * from "./GradientDonutChart.vue?vue&type=script&lang=js&"
import style0 from "./GradientDonutChart.vue?vue&type=style&index=0&id=34c5c044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c5c044",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34c5c044')) {
      api.createRecord('34c5c044', component.options)
    } else {
      api.reload('34c5c044', component.options)
    }
    module.hot.accept("./GradientDonutChart.vue?vue&type=template&id=34c5c044&scoped=true&", function () {
      api.rerender('34c5c044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ApexCharts/GradientDonutChart.vue"
export default component.exports